import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateFilters } from '../../../../../reducers/filtersSlice';
import DpeCheckbox from './DpeCheckbox';

const MoreCriteriaCheckbox = () => {
  const { collection: filtersCollection } = useSelector((state) => state.filters);
  const { more_criteria } = filtersCollection
  const dispatch = useDispatch();

  const otherCriterias = {
    hide_ground_floor: 'Pas de RDC',
    with_elevator: 'Ascenseur'
  }

  const annexeAreas = {
    with_cellar: 'Cave',
    with_parking: 'Parking',
    with_outsides: 'Espace extérieur'
  }

  const saleStates = {
    display_for_sale: 'Biens en vente',
    display_sold: 'Biens vendus',
  }

  const renovation = {
    with_renovation: 'Oui',
    without_renovation: 'Non',
  }

  const handleChange = (value) => {
    let newPayload = [...more_criteria]

    if (more_criteria.includes(value)) newPayload = more_criteria.filter(criteria => criteria !== value)
    else newPayload = [...more_criteria, value]

    dispatch(updateFilters(
      {...filtersCollection, more_criteria: newPayload}
    ))
  }

  const displayCriteria = (criteria) => (
    <div className='vesta-more-criteria-filter-container vesta-flex-row-start vesta-gap-15'>
      {Object.entries(criteria).map(([inputName, displayName], index) => (
        <div key={index} className='vesta-small-checkbox-card-container'>
          <input
            id={inputName}
            type='checkbox'
            name={inputName}
            value={inputName}
            checked={more_criteria.includes(inputName)}
            onClick={() => handleChange(inputName)}
            readOnly
          />

          <label htmlFor={inputName} className='vesta-small-checkbox-card vesta-margin-b-none'>
            <div className='vesta-checkbox-custom vesta-margin-r-10'>
              <i className='fa-solid fa-check vesta-no-margin-important'></i>
            </div>

            {displayName}
          </label>
        </div>
      ))}
    </div>
  )

  return(
    <>
      <div>
        <div className='typo-bold-content vesta-margin-b-10'>Autres critères</div>

        {displayCriteria(otherCriterias)}
      </div>

      <div>
        <div className='typo-bold-content vesta-margin-b-10'>Surfaces annexes</div>

        {displayCriteria(annexeAreas)}
      </div>

      <DpeCheckbox />

      <div>
        <div className='typo-bold-content vesta-margin-b-10'>Type de bien</div>

        {displayCriteria(saleStates)}
      </div>

      <div>
        <div className='typo-bold-content vesta-margin-b-10'>Travaux potentiels</div>

        {displayCriteria(renovation)}
      </div>
    </>
  )
};

export default MoreCriteriaCheckbox;
